// extracted by mini-css-extract-plugin
export default {"sectionRow":"styles_sectionRow__ibart","textIconSection":"styles_textIconSection__6BvHQ","label":"styles_label__xTmyB"};